var _clipPath, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .304h20v27H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.599 15.382a5.867 5.867 0 01-5.867-5.868 5.868 5.868 0 1111.735 0 5.867 5.867 0 01-5.868 5.868zM9.6.268a9.247 9.247 0 100 18.492A9.247 9.247 0 009.6.268z",
    fill: "url(#logo_inline_svg__logo_inline_svg___Radial2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.959 23.953V21.79a.579.579 0 00-.179-.433.605.605 0 00-.439-.176h-3.02a.605.605 0 00-.617.609v2.163H1.168V18.65h1.536v1.076c.198-.053.404-.079.617-.079h3.02c.599 0 1.106.209 1.525.628.418.418.628.923.628 1.515v2.163H6.959zm2.131-4.306h1.536v4.306H9.09zm7.142 5.512h.12c.174 0 .319-.06.439-.178a.582.582 0 00.179-.426.577.577 0 00-.179-.43.608.608 0 00-.439-.172h-3.02a2.08 2.08 0 01-1.525-.629 2.087 2.087 0 01-.627-1.529c0-.593.211-1.099.633-1.519.422-.42.928-.629 1.519-.629h.119v1.534h-.119a.605.605 0 00-.617.609c0 .172.059.319.178.438.12.12.266.179.439.179h3.02c.592 0 1.098.209 1.52.623.422.416.633.923.633 1.521 0 .605-.211 1.114-.633 1.53a2.09 2.09 0 01-1.52.623h-.12v-1.545z",
    fill: "#00aeef",
    fillRule: "nonzero"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "logo_inline_svg__logo_inline_svg___Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(15.672 -52.928 47.406) scale(15.20402)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0f3",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00aeef",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a96",
    stopOpacity: 1
  })))));
}

export default SvgLogoinline;